import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getTemplateConfig } from "./actions.js";

export const templateConfigEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = templateConfigEntityAdapter.getInitialState({});

export const templateConfigSlice = createSlice({
  name: "templateConfig",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTemplateConfig.fulfilled, (state, action) => {
      if (action.payload.status) {
        templateConfigEntityAdapter.setOne(state, action.payload.data);
      }
    });
  },
});

export default templateConfigSlice.reducer;
